module.exports = __webpack_public_path__ + "img/archive.f3f02f01.png";